import React from 'react';

const EstablishmentListTitle = ({ title }) => {
  return <div className="user-list-title">{title}</div>;
};

export default EstablishmentListTitle;
